import { render, staticRenderFns } from "./FooterMenuSection.vue?vue&type=template&id=7054f2b6&"
import script from "./FooterMenuSection.vue?vue&type=script&lang=js&"
export * from "./FooterMenuSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports